import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as actions from '../actions';

import noPlaylist from '../images/no-playlist.png';

class PlaylistPage extends Component {
  constructor(props){
    super(props);
    this.createPlaylist = this.createPlaylist.bind(this);
    this.deletePlaylist = this.deletePlaylist.bind(this);
  }

  componentDidMount(){
    let listId = this.props.match.params.id;
    let ownerId = this.props.match.params.owner;

    this.props.actions.setTokens(this.props.accessToken, this.props.refreshToken);
    this.props.actions.getPlaylist(ownerId, listId)
    .then(() => {
      this.props.actions.explicitCheck(this.props.playlist);
    });
  }

  createPlaylist(e){
    e.preventDefault();
    let userId = this.props.user.id;
    let name = this.props.playlist.name + ' (Clean)';
    
    this.props.actions.createPlaylist(userId, name)
    .then(() => {
      return this.props.actions.addTracks(userId, this.props.newlist.id, this.props.playlist.tracks.items);
    })
    .then(() => {
      this.props.history.push('/playlists');
    });
  }

  deletePlaylist(e){
    e.preventDefault();
    let userId = this.props.user.id;
    let playlistId = this.props.playlist.id;
    this.props.actions.deletePlaylist(userId, playlistId)
    .then(() => {
      this.props.history.push('/playlists');
    });
  }
  
  render() {
    if(!this.props.playlist){
      return (
        <h3>Loading Playlist details...</h3>
      );
    }
    
    let playlist = this.props.playlist;
    let explicitCount = this.props.explicit ? this.props.explicit.length : undefined;
    let img = noPlaylist;
    if(playlist.images.length){
      img = playlist.images[0].url;
    }

    return (
      <div>
      <div id="openModal" className="modalDialog">
        <div>
          <a href="#close" title="Close" className="close">X</a>
          <h2>Confirm Delete</h2>
          <p>Are you sure you want to delete this playlist? This cannot be reversed.</p>
          <a href="" onClick={this.deletePlaylist}>Delete Playlist</a>
        </div>
      </div>
      <div className="container">
        <div className="playlist">
          <Link to="/playlists">Back</Link>
          <div className="artwork">
            <img src={img} height="300" alt="Album Artwork" />
          </div>
          <div className="playlistDetail">
            <h3>{playlist.name}</h3>
            
            <h4>Owner: {playlist.owner.display_name}</h4>
            <h4>Tracks: {playlist.tracks.total}</h4>
            <h4>Explicit: {explicitCount}</h4>
            <h4>Actions:</h4>
            <hr />
            <a href={playlist.external_urls.spotify} target="_blank">Listen on Spotify</a>
            <br />
            <a href="#openModal">Delete</a>
            <br />
            <a href="" onClick={this.createPlaylist}>Clean</a>
          </div>
        </div>
      </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps){
  return {
    playlist: state.playlist.playlist,
    playlists: state.playlist.playlists,
    accessToken: state.currentUser.accessToken,
    refreshToken: state.currentUser.refreshToken,
    user: state.currentUser.user,
    explicit: state.playlist.explicit,
    newlist: state.playlist.newlist
  };
}

function mapDispatchToProps(dispatch){
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlaylistPage);


// WEBPACK FOOTER //
// ./src/components/PlaylistPage.js